// extracted by mini-css-extract-plugin
export default {"status":"SiteStatusChip_status__qvYTC"};